import { RaffleDefaultNumber } from "@components/raffles/default/number";
import { RaffleDefaultNumberHowItWorks } from "./how-it-works";
import { Masks } from "@hooks/functions/Masks/Masks";

export function RaffleDefaultNumberPreview() {
  const masks = new Masks();

  return (
    <>
      {/* How it Works */}
      <div className="row">
        <div className="col-md-12">
          <RaffleDefaultNumberHowItWorks />
        </div>
      </div>

      {/* Raffle Default Number Component */}
      <div className="row">
        <div className="col-md-12">
          <RaffleDefaultNumber />
        </div>
      </div>
    </>
  );
}
